$.ready(function() {
	game.panel.on('recall', function() {
		game.controller.socket.emit('recall');
	});
	
	game.showRecall = function(action) {
		/* global spinClear, spinInit, spinReady, spinDone */
		if (action.event === 'spin') {
			if (typeof action.request.bet !== 'undefined' && typeof action.request.coins === 'undefined') {
				action.request.coins = action.request.bet;
				delete action.request.bet;
			}
			
			game.panel.setBet(action.request);
			game.panel.setCredits(action.response.credits);
		}
		
		game.last = action.response;
		spinClear(true);
		spinInit(true);
		spinReady(true);
		spinDone(true);
	};
	
	game.controller.socket.on('recall', function(cycles) {
		if (!cycles) {
			return;
		}
		
		if (cycles.constructor === Array) {
			if (!cycles.length) {
				return;
			}
			
			game.recall.show(cycles);
		}
		
		else {
			game.panel.setRecall();
			loader.setRecall();
			game.inRecall = true;
			
			var counter = -1;
			var begun = false;
			var next = function(again) {
				counter = (counter + 1) % cycles.actions.length;
				
				var action = cycles.actions[counter];
				
				while ((begun && action.response.action === 'begin') || action.response.action === 'timer') {
					counter = (counter + 1) % cycles.actions.length;
					action = cycles.actions[counter];
				}
				
				var trigger = {
					delay: 5000,
					action: action,
				};
				
				game.trigger('recall_action', trigger);
				
				if (action.event === 'spin') {
					game.showRecall(action);
				}
				
				else if (action.event === 'feature') {
					var bonus = game.features[action.response.name];
					
					if (!bonus) {
						game.panel.dialog.show('fatal');
						
						return;
					}
					
					if (action.response.action === 'begin') {
						begun = true;
						
						if (game.panel.type === 'desktop') {
							game.panel.spin.remove();
							game.panel.play.removeClass('base');
							game.panel.play.addClass(bonus.key);
						}
						
						game.feature.active = action.response.name;
						game.feature.attr('class', 'active show');
						game.feature.messages.appendTo(game.feature);
						game.feature.messages2.appendTo(bonus);
						bonus.methods.init(true);
						bonus.appendTo(game.feature);
						
						game.addClass('bonus');
					}
					
					else if (action.response.action === 'finish') {
						begun = false;
						
						setTimeout(function() {
							game.removeClass('bonus');
							game.feature.removeClass('show');
							game.feature.empty();
							game.feature.attr('class', null);
							game.feature.hideMessages();
							
							game.feature.active = false;
						}, trigger.delay);
					}
					
					game.last = action.response;
					
					if (bonus.methods[action.response.action]) {
						bonus.methods[action.response.action](action.response, trigger);
					}
					
					if (action.response.action === 'spin') {
						game.panel.setWin(0, true);
						game.showRecall(action);
					}
				}
				
				else {
					console.log(counter, action);
				}
				
				if (again !== false) {
					setTimeout(next.bind(this), trigger.delay);
				}
			};
			
			next(false);
			
			if (cycles.actions.length === 1) {
				return;
			}
			
			game.on('ready', function() {
				setTimeout(function() {
					next();
				}, 5000);
			});
		}
	});
});



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/plugins/slot/public-src/common/js/recall.js
 **/